<template>
  <div class="w-100 d-flex flex-row mt-4 mb-4 overflow-hidden parent-container">
    <div class="container-fluid my-3">
      <div class="row mr-0 category-content" id="vodcategorycarousel">
        <div class="owl-carousel owl-theme" :id="'vodcatCarouselFunc'">
          <div
            class="item"
            v-for="(item_cat, index) in category"
            :key="'cat  - ' + index"
          >
            <div class="item_img" @click="goTo(item_cat.link)">
              <img v-bind:src="item_cat.bg_image_link" />
              <span>{{ item_cat.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import noimage from "../assets/noimage.png";
export default {
  data: function() {
    return {
      category: [],
      colors: [
        "bg-1",
        "bg-2",
        "bg-3",
        "bg-4",
        "bg-5",
        "bg-6",
        "bg-7",
        "bg-4", //festival
        "bg-8",
        "bg-9",
        "bg-10",
        "bg-11",
        "bg-12",
      ],
      backgroundImage: [
        "vod-category-1",
        "vod-category-2",
        "vod-category-3",
        "vod-category-4",
        "vod-category-2",
        "vod-category-6",
        "vod-category-1",
        "vod-category-5", //festival
        "vod-category-3",
        "vod-category-4",
        "vod-category-5",
        "vod-category-6",
        "vod-category-1",
      ],
    };
  },
  props: ["obj", "cat_id"],
  methods: {
    imageLoadError(event) {
      event.target.src = noimage;
    },
    initializeContentForStart() {
      var vm = this;
      var catArray = vm.obj;

      catArray.forEach((items, index) => {
        var link, random_color, random_bg_image;
        // const random_color = Math.floor(Math.random() * vm.colors.length)
        vm.colors.forEach((color, idx) => {
          if (index == idx) {
            random_color = color;
          } else if (index > vm.colors.length) {
            random_color = vm.colors[index - 7];
          }
        });

        // const random_bg_image = Math.floor(Math.random() * vm.colors.length)
        vm.backgroundImage.forEach((link, idx) => {
          if (index == idx) {
            random_bg_image = link;
          } else if (index > vm.backgroundImage.length) {
            random_bg_image = vm.backgroundImage[index - 7];
          }
        });

        link =
          "/viewall?cat=" +
          vm.convertStringToLower(items.replace(/\s/g, "")) +
          "&contenttype=vod&cat_id=" +
          this.cat_id[index];

        vm.category.push({
          name: items,
          link: link,
          bg_color: random_color,
          bg_image_link: `../assets/vod-category/${random_bg_image}.png`,
        });

        if (index <= catArray.length - 1) {
          setTimeout(
            function() {
              Vue.nextTick(
                function() {
                  vm.installOwlCarousel("#vodcatCarouselFunc");
                }.bind(vm)
              );
            }.bind(this),
            600
          );
        }
      });

      // console.log(JSON.stringify(this.category, null, 2))
    },
    convertStringToLower(items) {
      var strings;
      strings = items.toLowerCase();
      return strings;
    },
    goTo(link) {
      this.$router.push(link);
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: false,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-lg"></span>',
          '<span class="fa fa-chevron-right fa-lg"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            loop = false;
          }
        },
        responsive: {
          0: {
            items: 3,
            nav: false,
            margin: 10,
            stagePadding: 14,
          },
          768: {
            items: 3,
            nav: true,
            margin: 12,
            stagePadding: 20,
          },
          992: {
            items: 5,
            stagePadding: 14,
            loop: false,
            margin: 20,
          },
          1440: {
            items: 6,
            stagePadding: 14,
            loop: false,
            margin: 20,
          },
        },
      });
    },
  },
  beforeMount() {
    this.initializeContentForStart();
  },
};
</script>

<style scoped>
.parent-container {
  height: 100%;
}

.item {
  overflow: hidden;
}
.item-cat {
  width: 100%;
  padding-top: calc(164 / 247 * 100%);
  border-radius: 8px;
}

.item_img {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  padding-top: calc(164 / 247 * 100%);
  z-index: 1;
}
.item_img img {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.item_img span {
  position: absolute;
  height: 100%;
  overflow: hidden;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.18;
  display: flex;
  align-items: center;
  font-family: "Poppins", sans-serif !important;
}
.bg-1 {
  background: #e74c3c;
}
.bg-2 {
  background: #3498db;
}
.bg-3 {
  background: #16a085;
}
.bg-4 {
  background: #f1c40f;
}
.bg-5 {
  background: #d35400;
}
.bg-6 {
  background: #bdc3c7;
}
.bg-7 {
  background: #1abc9c;
}
.bg-8 {
  background: #f5b7b1;
}
.bg-9 {
  background: #82e0aa;
}
.bg-10 {
  background: #e74c3c;
}
.bg-11 {
  background: #8e44ad;
}
.bg-12 {
  background: #e74c3c;
}

@media only screen and (min-width: 2500px) {
  .parent-container {
    height: 400px;
  }
}

@media only screen and (max-width: 992px) {
  .item_img span {
    font-size: 16px;
  }
}
@media only screen and (max-width: 768px) {
  .item_img span {
    font-size: 14px;
  }
}
@media only screen and (max-width: 480px) {
  .item_img span {
    font-size: 12px;
  }
}
</style>

<style>
#vodcategorycarousel .owl-theme .owl-stage-outer {
  overflow: hidden;
}

@media only screen and (min-width: 992px) {
  #vodcategorycarousel .owl-theme .owl-stage-outer:hover {
    overflow: unset;
  }

  #vodcategorycarousel .owl-theme {
    height: fit-content;
  }
}

#vodcategorycarousel .owl-prev,
#vodcategorycarousel .owl-next {
  max-height: 100px;
  top: 30% !important;
  width: 40px;
  position: absolute;
}

#vodcategorycarousel .owl-prev,
#vodcategorycarousel .owl-next {
  width: 50px !important;
  height: 50px !important;
}

#vodcategorycarousel .owl-prev span,
.owl-next span {
  color: #fab900 !important;
}

#vodcategorycarousel .owl-prev {
  left: -14px !important;
  background-image: linear-gradient(to right, #000000, rgba(0, 0, 0, 0));
}

#vodcategorycarousel .owl-next {
  right: -14px !important;
  background-image: linear-gradient(to left, #000000, rgba(0, 0, 0, 0));
}

button:focus {
  outline: unset !important;
}

@media only screen and (max-width: 992px) {
  #vodcategorycarousel .owl-prev,
  #vodcategorycarousel .owl-next {
    top: 50px !important;
  }

  #vodcategorycarousel .owl-prev,
  #vodcategorycarousel .owl-next {
    width: 40px !important;
    height: 40px !important;
    font-size: 14px;
  }
}
@media only screen and (max-width: 768px) {
  #vodcategorycarousel .owl-prev,
  #vodcategorycarousel .owl-next {
    top: 40px !important;
  }
}
@media only screen and (max-width: 600px) {
  #vodcategorycarousel .owl-prev,
  #vodcategorycarousel .owl-next {
    top: 32% !important;
  }
}
@media only screen and (max-width: 480px) {
  #vodcategorycarousel .owl-prev,
  #vodcategorycarousel .owl-next {
    top: 25% !important;
  }
}
</style>
